<template>
    <div>
        <WebsiteHeader />
        <main>
            <div class="title1 helvetica">{{ error?.message }}</div>
        </main>
    </div>
</template>

<script lang="ts" setup>
import type { NuxtError } from "nuxt/app";

interface Props {
    error?: NuxtError
}
const props = defineProps<Props>()
</script>

<style lang="scss" scoped>
main {
    padding: var(--size-padding-header) var(--size-margin-page);
}
</style>